module.exports = __webpack_public_path__ + "images/bannerIT-a9a18c89cb431e01c1ff4ef91cdc715e.jpg";